import axios from 'axios'
import Utils from '../services/Utils'

axios.defaults.timeout = 30000
axios.defaults.urls = JSON.parse(process.env.VUE_APP_URL)
axios.defaults.ptApiUrl = axios.defaults.urls[window.apiDev ? 'dev' : 'prod'][window.apiKey].base
axios.defaults.storageApiUrl = axios.defaults.urls[window.apiDev ? 'dev' : 'prod'][window.apiKey].storage
Utils.updateAuthorization()


export default {
    getStrings(callback) {
        if (window.appCache && window.appCache.strings) {
            return Utils.processResponse({
                request: {
                    response: JSON.stringify({
                        success: true,
                        data: window.appCache.strings
                    })
                }
            }, callback)
        }
        axios.get(axios.defaults.ptApiUrl + 'translations?lng=' + window.language, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: axios.defaults.authorization,
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
}
